import { Col, Flex, Row, Switch, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../Components/Button"
import InputNumber from "../../../../../Components/Input/InputNumber"

import styles from "./dimmed.module.less"

const { Text } = Typography

const RepeatDisputerSection = ({ locked, fetching, enabled, threshold, onToggle, onEdit }) => {
  const { t } = useTranslation()

  return (
    <Row gutter={[24, 24]}>
      <Col flex="1 1 300px">
        <Flex vertical gap={4} style={{ maxWidth: 500 }}>
          <Text strong>{t("Repeat disputers")}</Text>
          <Text type="secondary">
            {t(
              "Customers who dispute again and again usually deserve a closer look than a template response. Once a customer hits your number, Recover stops auto-submitting their disputes and hands them to your team."
            )}
          </Text>
        </Flex>
      </Col>

      <Col flex="0 1 420px">
        <Flex vertical gap={24}>
          <Flex gap={12} align="center">
            <Switch checked={enabled} onChange={onToggle} disabled={fetching || locked} />
            <Text>{t("Send repeat disputers to manual review")}</Text>
          </Flex>

          <Flex vertical gap={8} className={locked || !enabled ? styles.dimmed : ""}>
            <Text>{t("Start reviewing by hand at")}</Text>
            <Flex gap={12}>
              <InputNumber
                addonAfter={<Text type="secondary">{t("Disputes per customer")}</Text>}
                // Toggle off = the feature does nothing, so the field reads 0.
                value={enabled ? Number(threshold || 0) : 0}
                disabled
                style={{ width: "100%" }}
              />
              <Button
                size="large"
                disabled={locked || !enabled}
                onClick={onEdit}
                text={t("Edit")}
              />
            </Flex>
            <Text type="secondary" style={{ fontSize: 14 }}>
              {t(
                "Counts every dispute that customer has ever filed against you, not just recent ones. Applies to disputes that arrive from now on."
              )}
            </Text>
          </Flex>
        </Flex>
      </Col>
    </Row>
  )
}

export default RepeatDisputerSection
